// extracted by mini-css-extract-plugin
export default {"list":"styles_list__o0uPr","message":"styles_message__DYM7f"};